var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravelAirportBaggageCheckBaggageTravelAdventureLuggageBagChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4622 3.28516C16.0142 3.28516 16.4622 3.73316 16.4622 4.28516V6.28516H20.4622C21.0142 6.28516 21.4622 6.73316 21.4622 7.28516V19.2852H23.4622V21.2852H1.46216V19.2852H3.46216V7.28516C3.46216 6.73316 3.91016 6.28516 4.46216 6.28516H8.46216V4.28516C8.46216 3.73316 8.91016 3.28516 9.46216 3.28516H15.4622ZM8.46216 8.28516H5.46216V19.2852H8.46216V8.28516ZM14.4622 8.28516H10.4622V19.2852H14.4622V8.28516ZM19.4622 8.28516H16.4622V19.2852H19.4622V8.28516ZM14.4622 5.28516H10.4622V6.28516H14.4622V5.28516Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelAirportBaggageCheckBaggageTravelAdventureLuggageBagChecked);
export default __webpack_public_path__ + "static/media/travel-airport-baggage--check-baggage-travel-adventure-luggage-bag-checked.e1a6a78c9efc0c2504698f070d451391.svg";
export { ForwardRef as ReactComponent };